import UploadImageDescription from './description';
import Images from './images';
import Uploader from './uploader';

type TUploadImageProps = {
  images: Array<IUploadImage>;
  setImages: React.Dispatch<React.SetStateAction<IUploadImage[]>>;
  setOldImages?: React.Dispatch<React.SetStateAction<IOldImage[]>>;
};

const UploadImage = ({images, setImages, setOldImages}: TUploadImageProps) => {
  return (
    <>
      <div>
        <span className="font-extrabold text-gray-6"> عکس آگهی</span>
      </div>
      <div className="mt-1">
        <UploadImageDescription />
        <Uploader setFile={setImages} />
        {images && images.length > 0 && (
          <Images
            setOldImages={setOldImages}
            images={images}
            setFile={setImages}
          />
        )}
      </div>
    </>
  );
};

export default UploadImage;
